import { debounceTime } from 'rxjs/operators';

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'input-search',
  templateUrl: './input.search.html',
})
export class InputSearch implements OnInit {
  @Input() loading = false;
  @Input() delay = 500;
  @Input() placeholder = 'Search';
  @Output() textChange = new EventEmitter<any>();
  model = '';
  control: FormControl = new FormControl();

  ngOnInit() {
    this.control.valueChanges.pipe(debounceTime(this.delay)).subscribe(from => {
      this.textChange.emit(this.control.value.trim());
    });
  }

  setVal(str) {
    this.control.patchValue(str);
  }
}
